export const resetPassword = gql`
    mutation resetPassword(
        $email: String
        $password: String
        $token: String
    ) {
        resetPassword(
            input:{
                email: $email,
                password: $password
                token: $token
            }) {
            status
            message
        }
    }
`
